"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnnotationImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing Annotation operations. */
var AnnotationImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class Annotation class.
   * @param client Reference to the service client
   */
  function AnnotationImpl(client) {
    (0, _classCallCheck2["default"])(this, AnnotationImpl);
    this.client = client;
  }
  /**
   *  (Auth: RhinestoneAuthorize[contextId, portalId])
   * @param portalId (Access Controlled)
   * @param contextId (Access Controlled)
   * @param assetItemId
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(AnnotationImpl, [{
    key: "getAnnotationTarget",
    value: function getAnnotationTarget(portalId, contextId, assetItemId, options) {
      var operationArguments = {
        portalId: portalId,
        contextId: contextId,
        assetItemId: assetItemId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getAnnotationTargetOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[contextId, portalId])
     * @param portalId (Access Controlled)
     * @param contextId (Access Controlled)
     * @param targetId
     * @param options The options parameters.
     */

  }, {
    key: "getAnnotations",
    value: function getAnnotations(portalId, contextId, targetId, options) {
      var operationArguments = {
        portalId: portalId,
        contextId: contextId,
        targetId: targetId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getAnnotationsOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[contextId, portalId])
     * @param portalId (Access Controlled)
     * @param contextId (Access Controlled)
     * @param targetId
     * @param body
     * @param options The options parameters.
     */

  }, {
    key: "postHtmlAnnotation",
    value: function postHtmlAnnotation(portalId, contextId, targetId, body, options) {
      var operationArguments = {
        portalId: portalId,
        contextId: contextId,
        targetId: targetId,
        body: body,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, postHtmlAnnotationOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[contextId, portalId])
     * @param portalId (Access Controlled)
     * @param contextId (Access Controlled)
     * @param targetId
     * @param options The options parameters.
     */

  }, {
    key: "getPdfAnnotations",
    value: function getPdfAnnotations(portalId, contextId, targetId, options) {
      var operationArguments = {
        portalId: portalId,
        contextId: contextId,
        targetId: targetId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getPdfAnnotationsOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[contextId, portalId])
     * @param portalId (Access Controlled)
     * @param contextId (Access Controlled)
     * @param targetId
     * @param body
     * @param options The options parameters.
     */

  }, {
    key: "postPdfAnnotation",
    value: function postPdfAnnotation(portalId, contextId, targetId, body, options) {
      var operationArguments = {
        portalId: portalId,
        contextId: contextId,
        targetId: targetId,
        body: body,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, postPdfAnnotationOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[contextId, portalId])
     * @param portalId (Access Controlled)
     * @param contextId (Access Controlled)
     * @param targetId
     * @param options The options parameters.
     */

  }, {
    key: "getHtmlAnnotations",
    value: function getHtmlAnnotations(portalId, contextId, targetId, options) {
      var operationArguments = {
        portalId: portalId,
        contextId: contextId,
        targetId: targetId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getHtmlAnnotationsOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[contextId, portalId])
     * @param portalId (Access Controlled)
     * @param contextId (Access Controlled)
     * @param annotationId
     * @param body
     * @param options The options parameters.
     */

  }, {
    key: "putAnnotation",
    value: function putAnnotation(portalId, contextId, annotationId, body, options) {
      var operationArguments = {
        portalId: portalId,
        contextId: contextId,
        annotationId: annotationId,
        body: body,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, putAnnotationOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[contextId, portalId])
     * @param portalId (Access Controlled)
     * @param contextId (Access Controlled)
     * @param annotationId
     * @param options The options parameters.
     */

  }, {
    key: "deleteAnnotation",
    value: function deleteAnnotation(portalId, contextId, annotationId, options) {
      var operationArguments = {
        portalId: portalId,
        contextId: contextId,
        annotationId: annotationId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, deleteAnnotationOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[contextId, portalId])
     * @param portalId (Access Controlled)
     * @param contextId (Access Controlled)
     * @param annotationId
     * @param body
     * @param options The options parameters.
     */

  }, {
    key: "putPdfAnnotation",
    value: function putPdfAnnotation(portalId, contextId, annotationId, body, options) {
      var operationArguments = {
        portalId: portalId,
        contextId: contextId,
        annotationId: annotationId,
        body: body,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, putPdfAnnotationOperationSpec);
    }
  }]);
  return AnnotationImpl;
}(); // Operation Specifications


exports.AnnotationImpl = AnnotationImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var getAnnotationTargetOperationSpec = {
  path: "/api/Portals({portalId})/Context({contextId})/Target({assetItemId})",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.AnnotationTargetInfo
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.contextId, Parameters.assetItemId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getAnnotationsOperationSpec = {
  path: "/api/Portals({portalId})/Context({contextId})/Target({targetId})/Annotation",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AnnotationModel"
            }
          }
        }
      }
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.contextId, Parameters.targetId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var postHtmlAnnotationOperationSpec = {
  path: "/api/Portals({portalId})/Context({contextId})/Target({targetId})/Annotation",
  httpMethod: "POST",
  responses: {
    200: {
      bodyMapper: Mappers.HtmlAnnotationModel
    },
    401: {},
    403: {}
  },
  requestBody: Parameters.body1,
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.contextId, Parameters.targetId],
  headerParameters: [Parameters.accept, Parameters.contentType],
  mediaType: "json",
  serializer: serializer
};
var getPdfAnnotationsOperationSpec = {
  path: "/api/Portals({portalId})/Context({contextId})/Target({targetId})/PdfAnnotation",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "PdfAnnotationModel"
            }
          }
        }
      }
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.contextId, Parameters.targetId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var postPdfAnnotationOperationSpec = {
  path: "/api/Portals({portalId})/Context({contextId})/Target({targetId})/PdfAnnotation",
  httpMethod: "POST",
  responses: {
    200: {
      bodyMapper: Mappers.PdfAnnotationModel
    },
    401: {},
    403: {}
  },
  requestBody: Parameters.body2,
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.contextId, Parameters.targetId],
  headerParameters: [Parameters.accept, Parameters.contentType],
  mediaType: "json",
  serializer: serializer
};
var getHtmlAnnotationsOperationSpec = {
  path: "/api/Portals({portalId})/Context({contextId})/Target({targetId})/HtmlAnnotation",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "HtmlAnnotationModel"
            }
          }
        }
      }
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.contextId, Parameters.targetId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var putAnnotationOperationSpec = {
  path: "/api/Portals({portalId})/Context({contextId})/Annotation({annotationId})",
  httpMethod: "PUT",
  responses: {
    200: {
      bodyMapper: Mappers.HtmlAnnotationModel
    },
    401: {},
    403: {}
  },
  requestBody: Parameters.body3,
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.contextId, Parameters.annotationId],
  headerParameters: [Parameters.accept, Parameters.contentType],
  mediaType: "json",
  serializer: serializer
};
var deleteAnnotationOperationSpec = {
  path: "/api/Portals({portalId})/Context({contextId})/Annotation({annotationId})",
  httpMethod: "DELETE",
  responses: {
    200: {},
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.contextId, Parameters.annotationId],
  serializer: serializer
};
var putPdfAnnotationOperationSpec = {
  path: "/api/Portals({portalId})/Context({contextId})/PdfAnnotation({annotationId})",
  httpMethod: "PUT",
  responses: {
    200: {
      bodyMapper: Mappers.PdfAnnotationModel
    },
    401: {},
    403: {}
  },
  requestBody: Parameters.body4,
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.contextId, Parameters.annotationId],
  headerParameters: [Parameters.accept, Parameters.contentType],
  mediaType: "json",
  serializer: serializer
};